import React from 'react';
import { TagOutlined } from '@ant-design/icons';
import { Button } from 'antd';
import { Label, LabelEntityType } from '../../types/labels';
import PartsLabelsManagementPage from '../parts_labels_management_page/PartsLabelsManagementPage';

type PartsLabelCreationButtonProps = {
	targetCollectionName: LabelEntityType;
	// When provided, the per-label count in the sidebar becomes clickable — the
	// sidebar closes and the caller applies that label as the page filter.
	onLabelCountClick?: (label: Label) => void;
	onLabelsCatalogueSaved?: () => void | Promise<void>;
	// Parts table collection whose filters may reference a deleted label.
	listTargetCollectionName?: string;
};

// Parts index "Labels" trigger button — opens the shared parts label-management
// drawer. Historical public API: PartsIndexPage just mounts this.
export default function PartsLabelCreationButton({
	targetCollectionName,
	onLabelCountClick,
	onLabelsCatalogueSaved,
	listTargetCollectionName,
}: PartsLabelCreationButtonProps): React.ReactElement {
	const [drawerOpen, setDrawerOpen] = React.useState(false);

	const handleLabelCountClick = (label: Label) => {
		setDrawerOpen(false);
		if (onLabelCountClick) onLabelCountClick(label);
	};

	return (
		<div>
			<Button
				size="large"
				icon={<TagOutlined translate="" />}
				onClick={() => setDrawerOpen(true)}
				className="shrink-0"
			/>
			{drawerOpen ? (
				<PartsLabelsManagementPage
					onClose={() => setDrawerOpen(false)}
					targetCollectionName={targetCollectionName}
					onLabelCountClick={onLabelCountClick ? handleLabelCountClick : undefined}
					onLabelsCatalogueSaved={onLabelsCatalogueSaved}
					listTargetCollectionName={listTargetCollectionName}
				/>
			) : null}
		</div>
	);
}
